<template>
  <i>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path :d="mdiMagnify" />
    </svg>
  </i>
</template>

<script setup>
import { mdiMagnify } from "@mdi/js";
</script>